module.exports = __webpack_public_path__ + "img/CB2-Off-1.7646e1d7.gif";